import { Box, Text } from '@betterment/samba-react';
import { SambaAutoLink } from '@betterment/shared-components';

import { trackClick } from '../../features/track';
import { ContentCardProps } from '../data';

export const WithdrawalBanner: React.FC<ContentCardProps> = ({
  description,
  linkText,
  url,
  handleCardClick,
  trackingModule: eventModule,
  trackingFlow: eventFlow,
  extras: { name: eventName, linkTarget },
}) => {
  const hasLink = linkText && url;

  return (
    <Box css={{ backgroundColor: 'background.info', p: 'space.300' }}>
      <Text dangerouslySetInnerHTML={{ __html: description }} />
      {hasLink && (
        <SambaAutoLink
          to={url}
          target={linkTarget}
          rel="noopener noreferrer"
          onClick={(event: React.MouseEvent<HTMLAnchorElement>) => {
            trackClick({ name: `${eventName}_${linkText}`, module: eventModule, flow: eventFlow });
            handleCardClick(event);
          }}
        >
          {linkText}
        </SambaAutoLink>
      )}
    </Box>
  );
};
